import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { initTelemetry } from './lib/telemetry'
import './index.css'

initTelemetry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
